import type { TroubleshootingFunnelKey } from '@openx/types/troubleshootingFunnel.ts';
import { useTranslation } from 'react-i18next';

type FunnelStepValues = { title: string; tableTitle: string; singleDiscardReason?: string; volumeColumnLabel?: string };

export const useFunnelTranslations = (): Record<keyof TroubleshootingFunnelKey, FunnelStepValues> => {
  const { t } = useTranslation();

  return {
    bid_responses: {
      tableTitle: t('Loss'),
      title: t('Bid Responses'),
    },
    eligible_bid_requests: {
      singleDiscardReason: t('Requests not targeted by your deal'),
      tableTitle: t('Deal Targeting'),
      title: t('Total Eligible Requests'),
      volumeColumnLabel: t('Volume'),
    },
    fills: {
      singleDiscardReason: t('Bids lost in external auction'),
      tableTitle: t('Fills Without Impression'),
      title: t('Fills'),
      volumeColumnLabel: t('Filtered Value'),
    },
    impressions: {
      tableTitle: t(''),
      title: t('Impressions'),
    },
    targeted_bid_requests: {
      singleDiscardReason: t('No Bid Response'),
      tableTitle: t('Requests with No Bid'),
      title: t('Eligible Targeted Requests'),
      volumeColumnLabel: t('Volume'),
    },
  };
};
